import { z } from "zod";
import { paginationResponseType } from "@/types";

// ============ CREATE ============
export type createClientSellerState = {
    success?: boolean;
    message?: string;
    errors?: {
        clientCode?: string[];
        clientUserName?: string[];
        clientName?: string[];
        observation?: string[];
        sellerId?: string[];
    };
    values?: {
        clientCode: string;
        clientUserName: string;
        clientName: string;
        observation: string;
        sellerId: string;
    };
};

export const createClientSellerSchema = z.object({
    clientCode: z.string()
        .min(4, { message: "Código deve ter pelo menos 4 caracteres" })
        .max(4, { message: "Código não pode exceder 4 caracteres" }),
    clientUserName: z.string()
        .min(2, { message: "Nome deve ter pelo menos 2 caracteres" })
        .max(100, { message: "Nome não pode exceder 100 caracteres" }),
    clientName: z.string()
        .min(2, { message: "Nome deve ter pelo menos 2 caracteres" })
        .max(100, { message: "Nome não pode exceder 100 caracteres" }),
    observation: z.string().optional(),
    sellerId: z.uuid("ID do vendedor deve ser um UUID válido"),
});

export type CreateClientSellerType = {
    clientCode: string;
    clientUserName: string;
    clientName: string;
    observation: string | null;
    sellerId: string;
};

// ============ DELETE ============
export type deleteClientSellerType = {
    id: string;
    sellerId: string;
};

// ============ GET ============
export type clientSellerResponseType = {
    id: string,
    client: {
        name: string;
        role: string;
        code: string;
        id: string;
        userName: string | null;
    };
    seller: {
        name: string;
        code: string;
        id: string;
        userName: string | null;
    };
    observation: string | null,
    createdAt: string,
    updatedAt: string,
};

export const defaultClientSeller: clientSellerResponseType = {
    id: '',
    client: {
        name: '',
        role: '',
        code: '',
        id: '',
        userName: '',
    },
    seller: {
        name: '',
        code: '',
        id: '',
        userName: '',
    },
    observation: '',
    createdAt: '',
    updatedAt: '',
};

export type ClientSellerResponse = {
    data: clientSellerResponseType[];
    pagination: paginationResponseType;
};

// ============ UPDATE ============
export type UpdateClientSellerType = {
    id: string;
    clientCode: string;
    clientUserName: string;
    clientName: string;
    observation?: string;
};

export type UpdateClientSellerState = {
    success?: boolean;
    message?: string;
    errors?: {
        id?: string[];
        clientCode?: string[];
        clientUserName?: string[];
        clientName?: string[];
        observation?: string[];
    };
    values?: {
        id: string;
        clientCode: string;
        clientUserName: string;
        clientName: string;
        observation: string;
    };
};

export const updateClientSellerSchema = z.object({
    id: z.uuid(),
    clientCode: z.string()
        .min(4, { message: "Código deve ter pelo menos 4 caracteres" })
        .max(4, { message: "Código não pode exceder 4 caracteres" }),
    clientUserName: z.string()
        .min(2, { message: "Nome deve ter pelo menos 2 caracteres" })
        .max(100, { message: "Nome não pode exceder 100 caracteres" }),
    clientName: z.string()
        .min(2, { message: "Nome deve ter pelo menos 2 caracteres" })
        .max(100, { message: "Nome não pode exceder 100 caracteres" }),
    observation: z.string().optional(),
});

// ============ TIPOS COMPLETOS ============
export type ClientSellerType = {
    id: string;
    clientCode: string;
    clientUserName: string;
    clientName: string;
    observation: string | null;
    createdAt: string;
    updatedAt: string;
    sellerId: string;
    seller?: {
        code: string;
        userName: string;
    };
};

export type ClientSellersResponse = {
    data: ClientSellerType[];
    pagination: paginationResponseType;
};

// ============ TIPOS PARA FORMULÁRIOS ============
export type CreateClientSellerFormData = {
    clientCode: string;
    clientUserName: string;
    clientName: string;
    observation?: string;
    sellerId: string;
};

export type UpdateClientSellerFormData = {
    id: string;
    clientCode?: string;
    clientUserName?: string;
    clientName?: string;
    observation?: string;
    sellerId?: string;
};